<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style class="admin_secondary">
            <v-card-title class="secondary white--text">
              <v-text-field
                dark
                hide-details
                label="Title"
                v-if="edit_title"
                v-model="project.title"
                @click:append="edit_title=false"
                append-icon="fa fa-check"
              ></v-text-field>
              <span class="clicky" @click="edit_title=true" v-else>{{project.title}}</span>
              <v-spacer></v-spacer>
              <v-btn
                small
                color="warning"
                @click="createRevision()"
                v-if="canCreateRevisions && !revisions.length"
                class="mr-4"
              >
                <v-icon small class="mr-2">fa-plus</v-icon>Revision
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
              <v-btn icon dark @click="$router.go(-1)" exact>
                <v-icon>fa-times</v-icon>
              </v-btn>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="primary"
              ></v-progress-linear>
            </v-card-title>

            <v-card-actions class="cool_purple" v-if="project.contest">
              <v-icon dark>fa-gift</v-icon>
              <v-spacer></v-spacer>
              <router-link
                class="white--text nolink"
                :to="`/admin/contests/${project.contest.id}`"
              >{{project.contest.title}}</router-link>
              <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-actions :class="projectStatusColors[project.status]" id="project-status">
              <v-spacer></v-spacer>
              <span class="white--text">
                {{projectStatusLabels[project.status]}}
                <span class>({{project.status}})</span>
              </span>
              <v-spacer></v-spacer>
            </v-card-actions>

            <v-container fluid class="secondary pt-4 white--text" v-if="revisions.length">
              <!-- Section for revision info !-->
              <v-row v-for="(revision,i) in revisions" :key="i" align="start" justify="center">
                <v-col cols="12" md="3" lg="2" xl="1" class="text-center">
                  <revision-video v-model="revision.video"></revision-video>
                </v-col>
                <v-col cols="10" md="6" lg="5" xl="4" class="pr-1">
                  <v-textarea
                    dark
                    outlined
                    v-model="revision.note"
                    label="Revision message from editor"
                  ></v-textarea>
                </v-col>
                <v-col cols="2" md="3" lg="1" xl="1" class>
                  <v-btn icon dark @click="deleteRevision(revision)">
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>

            <v-container>
              <v-row>
                <v-col cols="12" xl="6" class="pt-0">
                  <v-container class="pt-0">
                    <v-row>
                      <v-col cols="12">
                        <video-section
                          :can_create_revisions="canCreateRevisions"
                          @create-revision="createRevision(1)"
                          @delete-revision="deleteRevision"
                          :videos="section_1.videos"
                          :revisions="section_1.revisions"
                          title="Intro &amp; Outro"
                        ></video-section>
                      </v-col>
                      <v-col cols="12">
                        <video-section
                          :can_create_revisions="canCreateRevisions"
                          @create-revision="createRevision(2)"
                          @delete-revision="deleteRevision"
                          :videos="section_2.videos"
                          :revisions="section_2.revisions"
                          title="The Story"
                        ></video-section>
                      </v-col>
                      <v-col cols="12">
                        <video-section
                          :can_create_revisions="canCreateRevisions"
                          @create-revision="createRevision(3)"
                          @delete-revision="deleteRevision"
                          :videos="section_3.videos"
                          :revisions="section_3.revisions"
                          title="Key Features"
                        ></video-section>
                      </v-col>
                      <v-col cols="12">
                        <video-section
                          :can_create_revisions="canCreateRevisions"
                          @create-revision="createRevision(4)"
                          @delete-revision="deleteRevision"
                          :videos="section_4.videos"
                          :revisions="section_4.revisions"
                          title="Favourite Thing"
                        ></video-section>
                      </v-col>
                      <v-col cols="12">
                        <video-section
                          :can_create_revisions="canCreateRevisions"
                          @create-revision="createRevision(5)"
                          @delete-revision="deleteRevision"
                          :videos="section_5.videos"
                          :revisions="section_5.revisions"
                          title="Complete video"
                          :single="true"
                        ></video-section>
                      </v-col>
                      <v-col cols="12" class="text-center" v-if="project.videos.length">
                        <div v-if="project.zip_url && project.zip_url !=='Generating'">
                          <v-btn
                            color="green"
                            dark
                            :href="project.zip_url"
                            target="_blank"
                          >Download zip</v-btn>
                          <v-btn text dark class="ml-2" @click="generateZip">Regenerate</v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            color="warning"
                            dark
                            v-if="project.zip_url==='Generating'"
                            @click="load"
                            :loading="loading"
                          >
                            Generating
                            <v-icon class="ml-2" :loading="true" small>fa-sync</v-icon>
                          </v-btn>

                          <v-btn
                            color="green"
                            dark
                            v-else
                            @click="generateZip"
                            :loading="loading"
                          >Generate Zip</v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" v-if="showDescription">
                        <v-card>
                          <v-card-title class="secondary white--text">
                            Project Description
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_description=!show_description">
                              <v-icon v-if="show_description">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_description">
                              <v-card-text class="pt-4">
                                <vue-editor v-model="project.description" />
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>
                        <v-card class="mt-4">
                          <v-card-title class="secondary white--text">
                            Mobile Summary
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_summary=!show_summary">
                              <v-icon v-if="show_summary">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_summary">
                              <v-card-text class="pt-4">
                                <v-textarea
                                  v-model="project.summary"
                                  :rows="5"
                                  persistent-hint
                                  outlined
                                  :hint="`${project.summary ? project.summary.length : 0}/100 Characters`"
                                ></v-textarea>
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>

                        <v-card class="mt-4">
                          <v-card-title class="secondary white--text">
                            URL Slug (SEO)
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_slug=!show_slug">
                              <v-icon v-if="show_slug">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_slug">
                              <v-card-text class="pt-4">
                                <v-text-field v-model="project.slug"></v-text-field>
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>

                        <v-card class="mt-4">
                          <v-card-title class="secondary white--text">
                            Tags
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_tags=!show_tags">
                              <v-icon v-if="show_tags">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_tags">
                              <v-container>
                                <v-row align="start">
                                  <v-col cols="8" lg="3">
                                    <v-text-field
                                      label
                                      outliend
                                      hide-details
                                      dense
                                      v-model="add_tag"
                                      v-on:keyup.enter="addTag"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="4" lg="2">
                                    <v-btn fab color="primary" dark small @click="addTag">
                                      <v-icon>fa-plus</v-icon>
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="12" lg="7" v-if="project.tags">
                                    <v-chip
                                      close
                                      class="ma-2"
                                      color="blue"
                                      dark
                                      v-for="(tag,s) in project.tags.split(',')"
                                      :key="s"
                                      @click:close="removeTag(tag)"
                                    >{{tag}}</v-chip>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12" xl="6" class="pt-0">
                  <v-container class="pt-0">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          outlined
                          dark
                          hide-details
                          type="number"
                          :value="owner.rank"
                          disabled
                          :label="`${owner.name}'s current Rank`"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          outlined
                          dark
                          hide-details
                          type="number"
                          v-model="project.rank"
                          label="Project Rank"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <quality-card
                          v-model="project.report"
                          :disabled="(project.status===11 || project.status===13) && project.report ? true : false"
                          @new="createQualityCard"
                        ></quality-card>
                      </v-col>
                      <v-col cols="12">
                        <v-card>
                          <v-card-title class="secondary white--text">
                            Notes
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_notes=!show_notes">
                              <v-icon v-if="show_notes">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_notes">
                              <v-card-text class="pt-4">
                                <v-textarea
                                  label="Curator"
                                  v-model="project.editor_notes"
                                  :rows="5"
                                  hide-details
                                  outlined
                                ></v-textarea>
                              </v-card-text>
                              <v-card-text>
                                <v-textarea
                                  label="Editor"
                                  v-model="project.publisher_notes"
                                  :rows="5"
                                  hide-details
                                  outlined
                                ></v-textarea>
                              </v-card-text>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-col>
                      <v-col cols="12" v-if="showPublication">
                        <v-card>
                          <v-card-title class="secondary white--text">
                            Publication
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show_publication=!show_publication">
                              <v-icon v-if="show_publication">fa-minus</v-icon>
                              <v-icon v-else>fa-chevron-down</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-expand-transition>
                            <div v-show="show_publication">
                              <v-card-text class="pt-4">
                                <v-text-field
                                  prepend-inner-icon="fab fa-youtube"
                                  label="Youtube link"
                                  v-model="project.url"
                                  @change="setThumbnail"
                                ></v-text-field>
                                <v-text-field
                                  prepend-inner-icon="fab fa-facebook"
                                  label="Facebook link"
                                  v-model="project.facebook_url"
                                ></v-text-field>
                                <v-text-field
                                  prepend-inner-icon="fab fa-instagram"
                                  label="Instagram link"
                                  v-model="project.instagram_url"
                                ></v-text-field>
                                <v-text-field
                                  prepend-inner-icon="fab fa-instagram"
                                  label="IGTV link"
                                  v-model="project.igtv_url"
                                ></v-text-field>
                                <v-text-field
                                  prepend-inner-icon="fab fa-linkedin"
                                  label="LinkedIn link"
                                  v-model="project.linkedin_url"
                                ></v-text-field>
                              </v-card-text>
                              <v-card-text>
                                <v-text-field
                                  prepend-inner-icon="fab fa-youtube"
                                  label="Thumbnail"
                                  v-model="project.thumbnail"
                                ></v-text-field>
                                <v-text-field
                                  prepend-inner-icon="fab fa-facebook"
                                  label="Thumbnail HD"
                                  v-model="project.thumbnail_large"
                                ></v-text-field>
                                <v-switch
                                  color="green"
                                  hide-details
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="project.visible"
                                  label="Visible"
                                ></v-switch>
                              </v-card-text>

                              <div v-if="project.thumbnail || project.thumbnail_large">
                                <a :href="project.url" target="_blank">
                                  <v-img
                                    :src="project.thumbnail_large ? project.thumbnail_large : project.thumbnail"
                                  ></v-img>
                                </a>
                              </div>
                            </div>
                          </v-expand-transition>
                        </v-card>
                      </v-col>

                      <!--
                    <v-col cols="12">
                      <v-card>
                        <v-card-title class="secondary white--text">
                          Transfer Project
                        </v-card-title>
                        <v-card-text class="pt-4">
                          <v-text-field v-if="owner" label="Current owner" :value="owner.name"></v-text-field>
                          <v-autocomplete v-if="users" :items="users" item-text="name" item-value="id" label="Transfer to" v-model="selected_account" clearable>
                          </v-autocomplete>
                        </v-card-text>
                        <v-card-actions class="grey lighten-3" v-if="selected_account">
                          <v-spacer></v-spacer>
                          <v-btn color="blue" dark @click="transferProject" :loading="loading">Transfer</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                      !-->
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="grey lighten-3" style="min-height:50px" v-if="modified">
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                dark
                v-if="modified"
                id="save-btn"
                @click="saveProject"
                :loading="loading"
              >Save</v-btn>
            </v-card-actions>
            <v-card-actions class="grey lighten-3" style="min-height:50px" v-else>
              <v-btn
                color="error"
                dark
                v-if="canDelete"
                @click="deleteProject"
                :loading="loading"
              >Delete</v-btn>
              <v-spacer></v-spacer>

              <v-btn
                color="blue"
                dark
                v-if="canWePublishApproval"
                @click="publishApproval"
                :loading="loading"
              >Confirm to publish</v-btn>
              <v-btn
                color="blue"
                dark
                v-if="canWeReadyForPublishing"
                @click="readyForPublishing"
                :loading="loading"
              >Approve</v-btn>
              <v-btn
                color="green"
                dark
                v-if="canWePublish"
                @click="published"
                :loading="loading"
              >Publish</v-btn>

              <v-btn
                color="blue"
                dark
                v-if="canWeEligble"
                @click="eligible"
                :loading="loading"
              >Eligible for contest</v-btn>
              <v-btn
                color="blue"
                dark
                v-if="canWeApproveForEditing"
                @click="approveForEditing"
                :loading="loading"
              >Curation confirmed</v-btn>
              <v-btn
                color="blue"
                dark
                v-if="canWeReadyForEditing"
                @click="readyForEditing"
                :loading="loading"
              >Editing confirmed</v-btn>
              <v-btn
                color="warning"
                dark
                v-if="canWeRequestRevisions"
                @click="requestRevisions"
                :loading="loading"
              >Request Revisions</v-btn>
              <v-btn
                color="warning"
                dark
                v-if="project.status===4"
                @click="revisionRequired"
                :loading="loading"
              >Confirm Revision Request</v-btn>
              <v-btn
                color="red"
                dark
                v-if="canWeReject"
                @click="rejectProject"
                :loading="loading"
              >Reject Project</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import videoSection from "./video-section";
import project_status_labels from "../project_status_labels.json";
import project_status_colors from "../project_status_colors.json";
import revisionVideo from "./revision-video";
import qualityCard from "./quality_card";
//import score_template from "./score_template.json"

export default {
  name: "",
  components: {
    videoSection,
    revisionVideo,
    qualityCard,
  },
  data: () => ({
    edit_title: false,
    project: {
      revisions: [],
      videos: [],
      contest: null,
      report: null,
    },
    accounts: [],
    selected_account: null,
    add_tag: "",
    show_slug: true,
    show_tags: true,
    show_notes: true,
    show_publication: true,
    show_description: true,
    show_summary: true,
    loading: false,
    modified: false,
    projectStatusLabels: project_status_labels,
    projectStatusColors: project_status_colors,
  }),
  created() {
    this.load();
  },
  watch: {
    project: {
      handler: function (to, from) {
        if (to.id && from.id) {
          this.modified = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    includeBonus() {
      if (this.project.contest) {
        if (
          this.project.contest.runner_ups.includes(this.project.id) ||
          this.project.contest.winner === this.project.id
        ) {
          return true;
        }
      }
      return false;
    },
    owner() {
      return this.accounts.find(
        function (a) {
          return a.id === this.project.account_id;
        }.bind(this)
      );
    },
    users() {
      return this.accounts.filter(
        function (a) {
          if (a.id === this.project.account_id) {
            return false;
          }
          return a.type === "user";
        }.bind(this)
      );
    },
    canDelete() {
      if (this.project.report) {
        return false;
      }
      if (this.project.videos.length) {
        return false;
      }
      return true;
    },
    showDescription() {
      return [8, 9, 10, 11].includes(this.project.status);
    },
    canWePublish() {
      if (!this.project.url) {
        return false;
      }
      if (!this.project.thumbnail) {
        return false;
      }
      if (!this.project.thumbnail_large) {
        return false;
      }
      if (!this.project.description) {
        return false;
      }
      if (!this.project.report) {
        return false;
      }
      return [10].includes(this.project.status);
    },
    canWeEligble() {
      if (!this.project.contest_id) {
        return false;
      }
      if ([2, 6].includes(this.project.status)) {
        return true;
      } else {
        return false;
      }
    },
    canWeReadyForPublishing() {
      return [9].includes(this.project.status);
    },
    canWePublishApproval() {
      return [8].includes(this.project.status);
    },
    showPublication() {
      return [8, 9, 10, 11].includes(this.project.status);
    },
    canCreateRevisions() {
      return [2].includes(this.project.status);
    },
    canWeReadyForEditing() {
      if (!this.project.report) {
        return false;
      }
      return [7].includes(this.project.status);
    },
    canWeApproveForEditing() {
      if (this.canWeEligble) {
        return false;
      }
      return [2, 3, 6].includes(this.project.status);
    },
    canWeRequestRevisions() {
      return (
        [2, 3].includes(this.project.status) && this.project.revisions.length
      );
    },
    canWeRequireRevisions() {
      return this.project.status === 4 && this.project.revisions.length;
    },
    canWeReject() {
      return [2, 3, 6, 7].includes(this.project.status);
    },
    revisions() {
      return this.project.revisions.filter((r) => {
        return !r.section;
      });
    },
    section_1() {
      return {
        revisions: this.project.revisions.filter((r) => {
          return r.section === 1;
        }),
        videos: this.project.videos.filter((v) => {
          return v.section === 1;
        }),
      };
    },
    section_2() {
      return {
        revisions: this.project.revisions.filter((r) => {
          return r.section === 2;
        }),
        videos: this.project.videos.filter((v) => {
          return v.section === 2;
        }),
      };
    },
    section_3() {
      return {
        revisions: this.project.revisions.filter((r) => {
          return r.section === 3;
        }),
        videos: this.project.videos.filter((v) => {
          return v.section === 3;
        }),
      };
    },
    section_4() {
      return {
        revisions: this.project.revisions.filter((r) => {
          return r.section === 4;
        }),
        videos: this.project.videos.filter((v) => {
          return v.section === 4;
        }),
      };
    },
    section_5() {
      return {
        revisions: this.project.revisions.filter((r) => {
          return r.section === 5;
        }),
        videos: this.project.videos.filter((v) => {
          return v.section === 5;
        }),
      };
    },
  },
  methods: {
    async transferProject() {
      if (!confirm("Sure you want to transfer this project ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "POST",
          url: `/account/admin/projects/${this.project.id}/transfer`,
          data: {
            account_id: this.selected_account,
          },
        });
      } catch (ex) {
        alert(ex.error);
      }
      this.load();
    },
    removeTag(tag) {
      //project.tags.splice(project.tags.indexOf(tag),1)
      let tags = this.project.tags.split(",");
      tags.splice(tags.indexOf(tag), 1);
      this.project.tags = tags.join(",");
    },
    addTag() {
      if (!this.project.tags) {
        this.project.tags = "";
      }
      let tags = this.project.tags.split(",");
      tags.push(this.add_tag);
      this.project.tags = tags.join(",");
      this.add_tag = "";
    },
    async deleteProject() {
      if (!confirm("Delete project ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "DELETE",
          url: `/account/admin/projects/${this.project.id}`,
        });
        this.$router.push(`/admin/projects/`);
      } catch (ex) {
        alert(ex.error);
      }
    },
    setThumbnail() {
      if (!this.project.url) {
        return;
      }
      let id = this.$helpers.youtubeId(this.project.url);
      this.project.thumbnail = `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
      this.project.thumbnail_large = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
    },
    async generateZip() {
      this.loading = true;
      await this.$api(`/account/admin/projects/${this.project.id}/zip`);
      this.project.zip_url = "Generating";
      this.loading = false;
    },
    createQualityCard() {
      let scores = {
        sound: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        video: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        presentation: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        dialogue: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        knowledge: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        structure: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        creativity: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        passion: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        b_roll: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        hidden_gems: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
      };

      for (var k in scores) {
        scores[k] = scores[k].slice(0, this.project.rank);
      }
      this.project.report = {
        score: scores,
        stars: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0].slice(0, this.project.rank),
        rank: this.project.rank,
        project_id: this.project.id,
        congrats_video: null,
        amount_earned: 0,
      };
    },
    async publishApproval() {
      if (!confirm("Approve publishing ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/publishing-approval`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async readyForPublishing() {
      if (!confirm("Ready for publishing ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/publishing-ready`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async eligible() {
      if (!confirm("Mark project as eligible ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/eligible`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async published() {
      if (!confirm("Publish project ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/published`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async readyForEditing() {
      if (!confirm("Ready for editing ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/ready-for-editing`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async approveForEditing() {
      if (!confirm("Confirm approval ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/approve-for-editing`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async requestRevisions() {
      if (!confirm("Confirm revision request ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/request-revision`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async revisionRequired() {
      if (!confirm("Confirm revision required ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/revision-required`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async rejectProject() {
      if (!confirm("Confirm rejection ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "GET",
          url: `/account/admin/projects/${this.project.id}/reject`,
        });
        this.load();
        this.scrollToStatus();
      } catch (ex) {
        alert(ex.error);
      }
    },
    async saveProject() {
      this.loading = true;
      try {
        await this.$api({
          method: "POST",
          url: `/account/admin/projects/${this.project.id}`,
          data: {
            title: this.project.title,
            revisions: this.project.revisions,
            editor_notes: this.project.editor_notes,
            publisher_notes: this.project.publisher_notes,
            url: this.project.url,
            facebook_url: this.project.facebook_url,
            instagram_url: this.project.instagram_url,
            igtv_url: this.project.igtv_url,
            linkedin_url: this.project.linkedin_url,
            thumbnail: this.project.thumbnail,
            thumbnail_large: this.project.thumbnail_large,
            description: this.project.description,
            summary: this.project.summary,
            tags: this.project.tags,
            visible: this.project.visible,
            rank: this.project.rank,
          },
        });
        await Promise.all(
          this.project.videos.map(
            function (video) {
              return this.saveVideo(video);
            }.bind(this)
          )
        );
        if (this.project.report) {
          await this.saveReport(this.project.report);
        }
        this.load();
      } catch (ex) {
        console.log("saveproject err", ex);
        this.modified = true;
        this.loading = false;
        alert(ex.error);
      }
    },
    async saveVideo(video) {
      await this.$api({
        method: "POST",
        url: `/account/admin/project-videos/${video.id}`,
        data: {
          revision_required: video.revision_required,
        },
      });
    },
    async saveReport(report) {
      await this.$api({
        method: "POST",
        url: report.id
          ? `/account/admin/project-reports/${report.id}`
          : `/account/admin/project-reports`,
        data: report,
      });
    },
    createRevision(section) {
      if (section) {
        this.project.revisions.push({
          note: "",
          video: "",
          section: section,
        });
      } else {
        this.project.revisions.push({
          note: "",
          video: "",
        });
      }
    },
    deleteRevision(revision) {
      if (!confirm("Sure you want to delete this ?")) {
        return;
      }
      this.project.revisions = this.project.revisions.filter((r) => {
        return r !== revision;
      });
    },
    async load() {
      this.loading = true;
      this.project = await this.$api(
        `/account/admin/projects/${this.$route.params.id}`
      );
      this.accounts = await this.$api(`/account/admin/accounts`);
      setTimeout(
        function () {
          this.modified = false;
        }.bind(this),
        100
      );
      this.loading = false;
    },
    scrollToSave() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#save-btn", {
            duration: 300,
            offset: 100,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
    scrollToStatus() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#project-status", {
            duration: 300,
            offset: 100,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        this.scrollToSave();
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
